var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"learning-path-progress-bar"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"track row no-gutters"},[_c('div',{staticClass:"bar",class:`col-${_vm.width}`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }